import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'assetCategory',
  getItemSize: () => 45,
  allowSearch: () => true,
  getValue: () => getSessionItem(getStorageKey(), {}).item?.assetCategoryId ?? 0,
  getOnChange: (self) => (each) =>
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.assetCategoryId = each.id
      draft.item.assetCategoryName = each.displayName
      draft.item.assetId = 0
      draft.item.assetName = ''
      draft.toleranceItems = []
      draft.toleranceItemsOriginal = []
      draft.warrantyItems = []
      draft.warrantyItemsOriginal = []
    }),
  allowMultiple: false,
})()
